import { render } from "./BriefTable.vue?vue&type=template&id=7f027ae4&scoped=true"
import script from "./BriefTable.vue?vue&type=script&lang=js"
export * from "./BriefTable.vue?vue&type=script&lang=js"

import "./BriefTable.vue?vue&type=style&index=0&id=7f027ae4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f027ae4"]])

export default __exports__